import icon from 'vue-svgicon';

icon.register({
    'bold/remove-square': {
        width: 16,
        height: 16,
        viewBox: '0 0 24 24',
        data: `<path pid="0" d="M22.455 0H1.545A1.547 1.547 0 0 0 0 1.545v20.909A1.547 1.547 0 0 0 1.545 24h20.91A1.547 1.547 0 0 0 24 22.454V1.545A1.547 1.547 0 0 0 22.455 0zm-4.748 16.292a1 1 0 0 1 0 1.414 1.028 1.028 0 0 1-1.414 0l-4.116-4.116a.252.252 0 0 0-.354 0l-4.116 4.116a1.02 1.02 0 0 1-1.414 0 1 1 0 0 1 0-1.414l4.116-4.116a.249.249 0 0 0 0-.353L6.293 7.706a1 1 0 0 1 1.414-1.414l4.116 4.116a.25.25 0 0 0 .354 0l4.116-4.116a1 1 0 0 1 1.414 1.414l-4.116 4.117a.249.249 0 0 0 0 .353z"/>`,
    },
});
